import { useTranslation } from 'react-i18next'

import { useDownloadStringFile } from '@percent/partner-dashboard/common/hooks/useDownloadStringFile/useDownloadStringFile'
import { ReactComponent as Download } from '@percent/partner-dashboard/common/assets/images/download.svg'
import styles from './SaveBackupCode.module.scss'
import { SaveBackupCodeStepProps } from './SaveBackupCode.types'
import { Button, Copy } from '@percent/lemonade'

export function SaveBackupCode({ signInToApp, otpCode = '' }: SaveBackupCodeStepProps) {
  const { t } = useTranslation()

  const downloadCode = useDownloadStringFile(otpCode, 'otp-backup.txt')

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <h1 className={styles.header}>{t('2fa.saveBackupCode')}</h1>
        <p className={styles.subtext}>{t('2fa.saveBackupCodeSubtext')}</p>
        <Button variant="secondary" disabled>
          {otpCode}
        </Button>
        <div className={styles.actionWrapper}>
          <div className={styles.copyWrapper}>
            <Copy text={otpCode} />
            <p className={styles.actionText}>{t('typography.copy')}</p>
          </div>
          <div className={styles.downloadWrapper}>
            <Download className={styles.download} onClick={downloadCode} />
            <p className={styles.actionText}>{t('typography.download')}</p>
          </div>
        </div>
        <div className={styles.separator} />
        <Button type="button" onClick={signInToApp}>
          {t('button.done')}
        </Button>
      </div>
    </div>
  )
}
